import { FC, memo } from 'react';

import { useNsTHelper } from 'src/utils/i18n';
import { PlusSubscriptionPlusIcon } from 'src/components/plusSubscription/modals/icons/Plus';

import styles from 'src/styles/common/plusSubscription/modal/features.module.scss';

export const PlusSubscriptionFeatures: FC = memo(() => {
  const tHelper = useNsTHelper('plusSubscription', 'modals.common.features');

  const items = [
    'donationPages',
    'donorProfiles',
    'totalCustomBranding',
    'rallyUpEmailEngine',
    'integrations',
    'emailMarketingIntegrations',
  ];

  return (
    <div className={styles.features}>
      {items.map((item) => (
        <div key={item} className={`${styles.item} ${item}`}>
          <PlusSubscriptionPlusIcon className={styles.icon} />
          <div className={styles.caption}>{tHelper(`${item}.caption`)}</div>
          <div className={styles.description}>{tHelper(`${item}.description`)}</div>
        </div>
      ))}
    </div>
  );
});
